import { render, staticRenderFns } from "./ExaminationFormatInputForm.vue?vue&type=template&id=5ee2d162&scoped=true&"
import script from "./ExaminationFormatInputForm.vue?vue&type=script&lang=js&"
export * from "./ExaminationFormatInputForm.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationFormatInputForm.vue?vue&type=style&index=0&id=5ee2d162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee2d162",
  null
  
)

export default component.exports